import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/data/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Soft%20abstract%20minimal%20background%20with%20gentle%20pastel%20mint%20green%20and%20warm%20cream%20gradient%20shapes%2C%20airy%20and%20clean%20modern%20aesthetic%2C%20subtle%20organic%20curves%2C%20light%20and%20fresh%20composition%2C%20high%20resolution%2C%20no%20text&width=1600&height=900&seq=hero-bg&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/70 to-background-50"></div>

      <div className="relative mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm font-medium text-primary-700">
          <i className="ri-sparkling-2-line"></i>
          {t("hero.eyebrow")}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 transition hover:bg-primary-600 cursor-pointer whitespace-nowrap sm:w-auto"
          >
            {t("hero.cta1")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-7 py-3.5 text-base font-semibold text-background-50 transition hover:bg-accent-600 cursor-pointer whitespace-nowrap sm:w-auto"
          >
            {t("hero.cta2")}
            <i className="ri-shopping-bag-3-line"></i>
          </a>
        </div>

        <p className="mt-6 flex items-center gap-2 text-sm text-foreground-500">
          <i className="ri-information-line"></i>
          {t("hero.note")}
        </p>
      </div>
    </section>
  );
}